"use strict";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _settle(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }

        value = value.v;
      } else {
        value.o = _settle.bind(null, pact, state);
        return;
      }
    }

    if (value && value.then) {
      value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
      return;
    }

    pact.s = state;
    pact.v = value;
    var observer = pact.o;

    if (observer) {
      observer(pact);
    }
  }
}

var _Pact =
/*#__PURE__*/
function () {
  function _Pact() {}

  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;

    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;

      if (callback) {
        try {
          _settle(result, 1, callback(this.v));
        } catch (e) {
          _settle(result, 2, e);
        }

        return result;
      } else {
        return this;
      }
    }

    this.o = function (_this) {
      try {
        var value = _this.v;

        if (_this.s & 1) {
          _settle(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle(result, 1, onRejected(value));
        } else {
          _settle(result, 2, value);
        }
      } catch (e) {
        _settle(result, 2, e);
      }
    };

    return result;
  };

  return _Pact;
}();

function _isSettledPact(thenable) {
  return thenable instanceof _Pact && thenable.s & 1;
}

function _for(test, update, body) {
  var stage;

  for (;;) {
    var shouldContinue = test();

    if (_isSettledPact(shouldContinue)) {
      shouldContinue = shouldContinue.v;
    }

    if (!shouldContinue) {
      return result;
    }

    if (shouldContinue.then) {
      stage = 0;
      break;
    }

    var result = body();

    if (result && result.then) {
      if (_isSettledPact(result)) {
        result = result.s;
      } else {
        stage = 1;
        break;
      }
    }

    if (update) {
      var updateValue = update();

      if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
        stage = 2;
        break;
      }
    }
  }

  var pact = new _Pact();

  var reject = _settle.bind(null, pact, 2);

  (stage === 0 ? shouldContinue.then(_resumeAfterTest) : stage === 1 ? result.then(_resumeAfterBody) : updateValue.then(_resumeAfterUpdate)).then(void 0, reject);
  return pact;

  function _resumeAfterBody(value) {
    result = value;

    do {
      if (update) {
        updateValue = update();

        if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
          updateValue.then(_resumeAfterUpdate).then(void 0, reject);
          return;
        }
      }

      shouldContinue = test();

      if (!shouldContinue || _isSettledPact(shouldContinue) && !shouldContinue.v) {
        _settle(pact, 1, result);

        return;
      }

      if (shouldContinue.then) {
        shouldContinue.then(_resumeAfterTest).then(void 0, reject);
        return;
      }

      result = body();

      if (_isSettledPact(result)) {
        result = result.v;
      }
    } while (!result || !result.then);

    result.then(_resumeAfterBody).then(void 0, reject);
  }

  function _resumeAfterTest(shouldContinue) {
    if (shouldContinue) {
      result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
      } else {
        _resumeAfterBody(result);
      }
    } else {
      _settle(pact, 1, result);
    }
  }

  function _resumeAfterUpdate() {
    if (shouldContinue = test()) {
      if (shouldContinue.then) {
        shouldContinue.then(_resumeAfterTest).then(void 0, reject);
      } else {
        _resumeAfterTest(shouldContinue);
      }
    } else {
      _settle(pact, 1, result);
    }
  }
}

function _continue(value, then) {
  return value && value.then ? value.then(then) : then(value);
}

var _iteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";

function _forTo(array, body, check) {
  var i = -1,
      pact,
      reject;

  function _cycle(result) {
    try {
      while (++i < array.length && (!check || !check())) {
        result = body(i);

        if (result && result.then) {
          if (_isSettledPact(result)) {
            result = result.v;
          } else {
            result.then(_cycle, reject || (reject = _settle.bind(null, pact = new _Pact(), 2)));
            return;
          }
        }
      }

      if (pact) {
        _settle(pact, 1, result);
      } else {
        pact = result;
      }
    } catch (e) {
      _settle(pact || (pact = new Pact()), 2, e);
    }
  }

  _cycle();

  return pact;
}

function _forOf(target, body, check) {
  if (typeof target[_iteratorSymbol] === "function") {
    var iterator = target[_iteratorSymbol](),
        step,
        pact,
        reject;

    function _cycle2(result) {
      try {
        while (!(step = iterator.next()).done && (!check || !check())) {
          result = body(step.value);

          if (result && result.then) {
            if (_isSettledPact(result)) {
              result = result.v;
            } else {
              result.then(_cycle2, reject || (reject = _settle.bind(null, pact = new _Pact(), 2)));
              return;
            }
          }
        }

        if (pact) {
          _settle(pact, 1, result);
        } else {
          pact = result;
        }
      } catch (e) {
        _settle(pact || (pact = new Pact()), 2, e);
      }
    }

    _cycle2();

    if (iterator.return) {
      var _fixup = function _fixup(value) {
        try {
          if (!step.done) {
            iterator.return();
          }
        } catch (e) {}

        return value;
      };

      if (pact && pact.then) {
        return pact.then(_fixup, function (e) {
          throw _fixup(e);
        });
      }

      _fixup();
    }

    return pact;
  } // No support for Symbol.iterator


  if (!("length" in target)) {
    throw new TypeError("Object is not iterable");
  } // Handle live collections properly


  var values = [];

  for (var i = 0; i < target.length; i++) {
    values.push(target[i]);
  }

  return _forTo(values, function (i) {
    return body(values[i]);
  }, check);
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var promisify = require('util.promisify');

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var hasTag = require('./has-tag');

var isSchemata = require('./is-schemata');

var isSchemataArray = require('./is-array');

var getType = require('./type-getter');

var convertCamelcaseToHuman = require('./camelcase-to-human-converter');

var validateArgumentStrategies = function validateArgumentStrategies() {
  function two(validateArgs) {
    var properties = {};
    var arg = validateArgs[1];
    properties.entityObject = validateArgs[0];
    properties.set = typeof arg !== 'function' ? arg : 'all';
    properties.tag = undefined;
    properties.callback = arg;
    return properties;
  }

  function three(validateArgs) {
    var arg = validateArgs[2];
    var properties = {};
    properties.entityObject = validateArgs[0];
    properties.set = validateArgs[1] || 'all';
    properties.tag = undefined;
    properties.callback = arg;
    return properties;
  }

  function four(validateArgs) {
    var properties = {};
    properties.entityObject = validateArgs[0];
    properties.set = validateArgs[1] || 'all';
    properties.tag = validateArgs[2];
    properties.callback = validateArgs[3];
    return properties;
  }

  return {
    '1': two,
    '2': two,
    '3': three,
    '4': four
  };
};
/*
 * Validate a property with a schemata as its type
 */


var validateSubschema = _async(function (entityObject, propertyName, property, set) {
  var type = getType(property.type, entityObject); // In order to validate, type must be a schemata instance

  if (!isSchemata(type)) return;
  if (!entityObject[propertyName]) return;
  return _await(type.validateRecursive(entityObject[propertyName], set, undefined, entityObject), function (errors) {
    return Object.keys(errors).length > 0 ? _defineProperty({}, propertyName, errors) : {};
  });
});
/*
 * Validate a property with a schemata array as its type
 */


var validateArraySchema = _async(function (entityObject, propertyName, property, set) {
  // In order to validate, type must be a schemata array and the property must be an array with length
  if (!isSchemataArray(property.type) || !Array.isArray(entityObject[propertyName]) || !entityObject[propertyName].length) return;
  var arrayErrors = {};
  var i = 0;
  return _continue(_for(function () {
    return i < entityObject[propertyName].length;
  }, function () {
    return i++;
  }, function () {
    return _await(property.type.arraySchema.validateRecursive(entityObject[propertyName][i], set, undefined, entityObject), function (errors) {
      if (Object.keys(errors).length > 0) {
        arrayErrors[i] = errors;
      }
    });
  }), function () {
    return Object.keys(arrayErrors).length > 0 ? _defineProperty({}, propertyName, arrayErrors) : {};
  });
});
/*
 * Validate a property with a primitive type
 */


var validateSimpleProperty = _async(function (entityObject, propertyName, property) {
  var _exit = false;
  var set = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'all';
  var parent = arguments.length > 4 ? arguments[4] : undefined;
  var validators = Array.isArray(property.validators) && set === 'all' ? property.validators : property.validators && property.validators[set];
  var errorName = property.name === undefined ? convertCamelcaseToHuman(propertyName) : property.name; // This property has no validators, or none specified for the given set

  if (validators === undefined || !Array.isArray(validators)) return;
  var promises = validators.map(function (validator) {
    if (validator.length === 3) {
      var response = validator(propertyName, errorName, entityObject);

      if (response instanceof Promise) {
        return response;
      } else {
        return new Promise(function (resolve) {
          return resolve(response);
        });
      }
    } else if (validator.length === 5) {
      return promisify(validator)(propertyName, errorName, entityObject, parent);
    } else if (validator.length === 4) {
      return promisify(validator)(propertyName, errorName, entityObject);
    }
  });
  return _continue(_forOf(promises, function (promise) {
    return _await(promise, function (invalid) {
      if (invalid) {
        _exit = true;
        return _defineProperty({}, propertyName, invalid);
      }
    });
  }, function () {
    return _exit;
  }), function (_result) {
    return _exit ? _result : false;
  });
});
/*
 * Run validation on a single property
 */


var validateProperty = function validateProperty(entityObject, propertyName, property, set, parent) {
  return _await(validateSimpleProperty(entityObject, propertyName, property, set, parent), function (response) {
    return response ? response : _await(validateSubschema(entityObject, propertyName, property, set), function (subSchemaResponse) {
      return subSchemaResponse ? subSchemaResponse : _await(validateArraySchema(entityObject, propertyName, property, set, parent), function (arraySchemaResponse) {
        return arraySchemaResponse ? arraySchemaResponse : {};
      });
    });
  });
};
/*
 * Recursively validates entity against the specified set, if set is not given the set 'all' will be assumed.
 */


var validateRecursive = function validateRecursive(internalSchema) {
  return _async(function (entityObject, set, tag, parent) {
    // Only validate the properties with the given tag
    var filteredProperties = Object.keys(internalSchema).reduce(function (propertiesNames, propertyName) {
      if (hasTag(internalSchema, propertyName, tag)) {
        propertiesNames.push(propertyName);
      }

      return propertiesNames;
    }, []);
    return _await(Promise.all(filteredProperties.map(function (propertyName) {
      return validateProperty(entityObject, propertyName, internalSchema[propertyName], set, parent || entityObject);
    })), function (_Promise$all) {
      return _Promise$all.reduce(function (errors, validationError) {
        if (!validationError) return errors;
        return _objectSpread({}, errors, validationError);
      }, {});
    });
  });
};

var validate = function validate(internalSchema) {
  return _async(function () {
    var entityObject;
    var set;
    var tag;
    var callback;
    var validateStrategy = validateArgumentStrategies();
    var properties;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (validateStrategy[args.length]) {
      properties = validateStrategy[args.length]([].concat(args));
      entityObject = properties.entityObject;
      set = properties.set;
      tag = properties.tag;
      callback = properties.callback;
    } else {
      throw new Error('Validate called with a bad number of arguments');
    }

    if (typeof callback === 'function') {
      validateRecursive(internalSchema)(entityObject, set, tag).then(function (response) {
        return callback(null, response);
      }).catch(callback);
    } else {
      return validateRecursive(internalSchema)(entityObject, set, tag);
    }
  });
};

module.exports = {
  validate: validate,
  validateRecursive: validateRecursive
};